// Modules
import React from 'react'
import PropTypes from 'prop-types'

// Hooks
import useLanguage from 'hooks/system/useLanguage'

// Styles
import './Fallback.scss'

// Component: Presentation > Fallback
function Fallback ({ children, className, hasData, isUpdating, style }) {
	// Data
	const { translate } = useLanguage('components.presentation.fallback')

	// Render
	if (!(isUpdating || !hasData)) return children
	return (
		<span
			data-presentation="fallback"
			className={
				'aix-fallback' +
				(className ? ` ${className}` : '')
			}
			style={style}>
			{/* TODO: Add spinner here */}
			<span data-suffix="…">
				{translate.global('format.threeDots', {
					reference: translate.global(`status.${hasData ? 'updatingData' : 'loadingData'}`)
				})}
			</span>
		</span>
	)
}

// Properties
Fallback.propTypes = {
	children: PropTypes.node,
	className: PropTypes.string,
	hasData: PropTypes.bool.isRequired,
	isUpdating: PropTypes.bool.isRequired,
	style: PropTypes.object
}
Fallback.defaultProps = {
	isUpdating: false
}

// Export
export default Fallback
